import React, { FC } from 'react';
import cx from 'classnames';

import styles from './textBlock.module.scss';

interface IProps {
  className?: string;
  html?: string;
}
/* eslint-disable react/jsx-props-no-spreading */
const TextBlock: FC<IProps> = ({
  children,
  className,
  html,
}) => (
  <div
    className={cx(styles.container, className)}
    {...(!!html && { dangerouslySetInnerHTML: { __html: html } })}
  >
    {children}
  </div>
);

export default TextBlock;
